import parse from 'html-react-parser';
import moment from 'moment';
import 'moment-timezone'; 
import { Buffer } from 'buffer';
moment.tz.setDefault('America/New_York');

export const parseHTML = (input) =>
  parse(input, {
    replace: (domNode) => {
      if (domNode instanceof Element && domNode.attribs.class === "remove") {
        return <></>;
      }
    },
  });

export const formatCommaNumbers = (number) => {
  let formattedNumber = Number(number);

  if (!isNaN(formattedNumber)) {
    return formattedNumber.toLocaleString("en-US");
  } else {
    return number;
  }
};
export const formatCommaNumbers2Decimals = (number) => {
  let formattedNumber = Number(number);

  if (!isNaN(formattedNumber)) {
      return formattedNumber.toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
      });
  } else {
      return number;
  }
};

export const formatMoneyNumber = (number) => {
  let formattedNumber = Number(number);

  if (!isNaN(formattedNumber)) {
    return formattedNumber.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  } else {
    return number;
  }
};

export const numberFormatInfluencer = (number) => {
  let formattedNumber = Number(number);
  if (formattedNumber === 0) {
    return "";
  }
  if (!isNaN(formattedNumber)) {
    return formattedNumber.toLocaleString("en-US");
  } else {
    return number;
  }
};
export const formatCurrency = (number) => {
  return number?.toLocaleString("en-US", {
    style: "currency",
    currency: "USD",
  });
};

export const getOrdinal = (n) => {
  let ord = "th";

  if (n % 10 == 1 && n % 100 != 11) {
    ord = "st";
  } else if (n % 10 == 2 && n % 100 != 12) {
    ord = "nd";
  } else if (n % 10 == 3 && n % 100 != 13) {
    ord = "rd";
  }

  return `${n}${ord}`;
};

export const formatNumberUnits = (num, precision = 1) => {
  const map = [
    { suffix: "T", threshold: 1e12 },
    { suffix: "B", threshold: 1e9 },
    { suffix: "M", threshold: 1e6 },
    { suffix: "K", threshold: 1e3 },
    { suffix: "", threshold: 1 },
  ];

  const found = map.find((x) => Math.abs(num) >= x.threshold);
  if (found) {
    const final = num / found.threshold;
    const fixed = final.toFixed(precision);

    if (fixed % 1 == 0) {
      return Math.round(fixed) + found.suffix;
    } else {
      return fixed + found.suffix;
    }
  }

  return Math.ceil(num * 100) / 100;
};

export const formatKey = (str) => {
  return str.replace(/([a-z])([A-Z])/g, "$1 $2");
};

export const setCookie = (cname, cvalue, exdays) => {
  const d = moment().tz("America/New_York");
  d.add(exdays, "days");
  let expires = "expires=" + d.format("ddd, DD MMM YYYY HH:mm:ss [EST]");
  document.cookie = `${cname}=${cvalue};${expires};path=/`;
};

export const acceptCookieConsent = (cookie_name) => {
  deleteCookie(cookie_name);
  setCookie(cookie_name, "dismiss", 30);
};

export const getCookie = (cname) => {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

export const deleteCookie = (cname) => {
  const d = moment().tz("America/New_York");
  d.add(1, "days");
  let expires = "expires=" + d.format("ddd, DD MMM YYYY HH:mm:ss [ET]");
  document.cookie = `${cname}=;${expires};path=/`;
};

export const formatDate = (date) => {
  return date ? moment(date).format("MM/DD/YYYY") : date;
};

export const formatDateTime = (datetime) => {
  return datetime ? moment(datetime).format("MM/DD/YYYY hh:mm A") : datetime;
};
export const isNumber = (evt) => {
  evt = evt ? evt : window.event;
  var charCode = evt.which ? evt.which : evt.keyCode;
  if (
    evt?.nativeEvent?.shiftKey == true ||
    charCode == 189 ||
    charCode == 109 ||
    charCode == 69
  ) {
    return true;
  }
  if (
    charCode == 190 ||
    charCode == 110 ||
    charCode == 37 ||
    charCode == 39 ||
    (charCode == 86 && evt?.nativeEvent?.ctrlKey == true) ||
    (charCode == 67 && evt?.nativeEvent?.ctrlKey == true) ||
    (95 < charCode && charCode < 106)
  ) {
    return false;
  }
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    return true;
  }
  return false;
};
export const isNumberWithoutDot = (evt) => {
  evt = evt ? evt : window.event;
  var charCode = evt.which ? evt.which : evt.keyCode;
  if (
    evt?.nativeEvent?.shiftKey == true ||
    charCode == 189 ||
    charCode == 109 ||
    charCode == 69
  ) {
    return true;
  }
  if (
    charCode == 110 ||
    charCode == 37 ||
    charCode == 39 ||
    (charCode == 86 && evt?.nativeEvent?.ctrlKey == true) ||
    (charCode == 67 && evt?.nativeEvent?.ctrlKey == true) ||
    (95 < charCode && charCode < 106)
  ) {
    return false;
  }
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    return true;
  }
  return false;
};
export const expoToString = (number) => {
  Number.prototype.noExponents = function () {
    const data = String(this).split(/[eE]/);
    if (data.length == 1) return data[0];

    let z = "";
    const sign = this < 0 ? "-" : "";
    const str = data[0].replace(".", "");
    let mag = Number(data[1]) + 1;

    if (mag < 0) {
      z = `${sign}0.`;
      while (mag++) z += "0";
      return z + str.replace(/^\-/, "");
    }
    mag -= str.length;
    while (mag--) z += "0";
    return str + z;
  };

  return number.noExponents();
};
export const countDecimal = (num) => String(num).split(".")[1]?.length || 0;

export const truncateToDecimals = (num, fixed) => {
  if (num !== NaN && num !== Infinity && num > 0) {
    var re = new RegExp("^-?\\d+(?:.\\d{0," + (fixed || -1) + "})?");
    return Number(num?.toString()?.match(re)[0]);
  }
  return 0;
};
export const toFix = (value, n) => {
  if (value == 0 || value == undefined) {
    return 0;
  } else {
    const v = value?.toString()?.split(".");
    if (v.length === 1 || (v.length > 1 && v[1].length === 0)) {
      return value;
    }
    if (n <= 0) return v[0];
    if (v?.length == 1) return Number(v[0])?.toFixed(n);
    let f = v[1] || "";
    if (f?.length > n) return `${v[0]}.${f?.substr(0, n)}`;
    while (f?.length < 2) f += "0";
    return `${v[0]}.${f}`;
  }
};
export const getTotalValue = (amount, price) => amount * price;

export const getMonthName = (monthNumber) => {
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  return monthNames[monthNumber - 1];
};

export const decodeJWT = (token) => {
  if (token) {
    const base64Url = token.split(".")[1];
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const buff = new Buffer(base64, "base64");
    const payloadinit = buff.toString("ascii");
    const payload = JSON.parse(payloadinit);
    return payload;
  } else {
    return {};
  }
};

// ********** SOCIAL MEDIA URL REGEX **********
export const socialMediaPatterns = {
  facebook: /^(https?:\/\/)?(www\.)?facebook\.com\//,
  instagram: /^(https?:\/\/)?(www\.)?instagram\.com\//,
  youtube: /^(https?:\/\/)?(www\.)?youtube\.com\//,
  tiktok: /^(https?:\/\/)?(www\.)?tiktok\.com\//,
  twitter: /^(https?:\/\/)?(www\.)?(twitter\.com|x\.com)\//,
};

export const isNumberTwodecimal = (evt) => {
  evt = evt ? evt : window.event;
  var charCode = evt.which ? evt.which : evt.keyCode;
  const value = evt.target.value;
  if (charCode == 46) {
    return false;
  }
  if (evt?.nativeEvent?.shiftKey == true) {
    return true;
  }
  if (charCode == 37 || charCode == 39) {
    return false;
  }
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
    return true;
  }
  const decimalIndex = value.indexOf('.');
  if (decimalIndex !== -1 && value.length - decimalIndex > 2) {
    return true;
  }
  return false;
};
